<template lang="pug">
.middle-box.text-center.loginscreen.animated.fadeInDown
  div
    div
      img(src='https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=250&name=Illustration%20-%20Homepage.png' style='width:250px;border-width:0px;border:0px;' width='250' alt='Backbar Home' srcset='https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=253&name=Illustration%20-%20Homepage.png 253w, https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=250&name=Illustration%20-%20Homepage.png 250w, https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=758&name=Illustration%20-%20Homepage.png 758w, https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=1010&name=Illustration%20-%20Homepage.png 1010w, https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=1263&name=Illustration%20-%20Homepage.png 1263w, https://www.getbackbar.com/hs-fs/hubfs/Web%20Design%20Assets%20/Illustrations/Illustration%20-%20Homepage.png?width=1515&name=Illustration%20-%20Homepage.png 1515w' sizes='(max-width: 250px) 100vw, 250px')
    h3 Welcome to Backbar!
    form#login-form.m-t.mb-3(v-on:submit.prevent='submitLoginForm' role='form')
      .form-group
        input#email.form-control(v-model='loginForm.email' type='email' placeholder='Email' required='')
      .form-group
        input#password.form-control(v-model='loginForm.password' type='password' placeholder='Password' required='')
      button#login-btn.btn.btn-primary.block.full-width.m-b(type='submit') Login
      hr
      router-link(to='/forgot-password')
        small Forgot password?
      p.text-muted.text-center
        small Don&apos;t have an account?
      router-link.btn.btn-sm.btn-white.btn-block(to='/signup') Create an account
.login-footer
  p.login-footer-left
    a(href='https://www.getbackbar.com' target='_blank') Learn more about Backbar
  p.login-footer-right
    small Backbar &copy;
    | {{ currentYear }}
</template>
<script lang="ts">
import '//js.hs-scripts.com/5163161.js'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      }
    }
  },
  mounted() {
    if (this.$route.query.reset_password) {
      this.$alerts.addAlert({
        title: 'Success! ',
        content: 'Your password has been reset.',
        class: 'alert-success'
      })
    }
    if (this.$route.query.email) {
      this.loginForm.email = this.$route.query.email as string
    }
  },
  methods: {
    ...mapActions(useUserStore, ['getUser']),
    submitLoginForm() {
      const thatVm = this
      $.post('/login', thatVm.loginForm)
        .done(async (data) => {
          if (data.success && data.banned == 0) {
            await this.getUser()
            /**
            window?.mixpanel?.track('Login')
            window?.mixpanel?.people.set({
              Email: this.user.email,
              'First Name': this.user.first_name,
              'Last Name': this.user.last_name,
              'Job Function': this.user.job_function,
              'User Create Date': this.user.create_date,
              'User Level': this.user.user_level,
              Organization: this.organization.name,
              Role: this.organization.role,
              Plan: this.organization.plan,
              Venue: this.currentVenue.name
            })*/
            //window?.mixpanel?.identify(this.user.id)
            setTimeout(() => {
              const redirectUrl = sessionStorage.getItem('redirectAfterLogin')
              if (redirectUrl) {
                sessionStorage.removeItem('redirectAfterLogin')
                this.$router.push(redirectUrl)
              } else if (this.IEWebBrowser == true) {
                this.$router.push({ name: 'iebrowser' })
              } else if (data.redirectTo) {
                // legacy redirection from BE. FE now handles this with sessionStorage above
                this.$router.push({ path: data.redirectTo })
              } else {
                this.$router.push(this.$route.redirectedFrom?.fullPath || { name: 'dashboard' })
              }
            }, 1000)
          } else if (data.failure) {
            if (data.error === 'too_many_failed_login_attempts') {
              this.$alerts.addAlert({
                title: 'Error: ',
                content:
                  'You have had too many unsuccessful login attempts. Please wait and try again in a few minutes.',
                class: 'alert-danger',
                timeout: 2500
              })
            } else if (data.error === 'invalid_password') {
              this.$alerts.addAlert({
                title: 'Error: ',
                content: 'Invalid email or password.',
                class: 'alert-danger',
                timeout: 2500
              })
            } else {
              this.$alerts.addAlert({
                title: 'Error: ',
                content: 'Something went wrong, please try again.',
                class: 'alert-danger',
                timeout: 2500
              })
            }
          }
        })
        .fail(() => {
          console.log('fail')
          this.$alerts.addAlert({
            title: 'Error: ',
            content: 'Login Failed',
            class: 'alert-danger'
          })
        })
    }
  },
  computed: {
    ...mapState(useUserStore, ['user', 'currentVenue']),
    ...mapState(useUserStore, {
      organization: 'currentOrganization'
    }),
    currentYear() {
      return new Date().getFullYear()
    },
    IEWebBrowser() {
      if (
        window.navigator.userAgent.indexOf('MSIE ') > 0 ||
        !!navigator.userAgent.match(/Trident.*rv:11\./)
      ) {
        return true
      } else {
        return false
      }
    }
  }
})
</script>
